import * as Yup from "yup"
import { AcademicLevel, Email, FirstName, LastName, MobilePhoneRequired, Consentement } from "services/validation"
import { atLeastOneProgram } from "../services/landingPages"

const schema = Yup.object().shape({
  ...Consentement,
  rendezVous: Yup.string().required('Veuillez choisir un type de rendez-vous'),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    PGE__c: Yup.boolean(),
    BMI__c: Yup.boolean()
  }).test('at-least-one-program', '', atLeastOneProgram(['PGE__c', 'BMI__c'], 'lead.programmes'))
})

export default schema
